/**
 * Tells if an URI is external or not
 *
 * Eg:
 * http://example.com is external
 * /a-page is not
 *
 */
export default (uri: string): boolean => /^(\w+:)?\/\//.test(uri);
